module.exports = __webpack_public_path__ + "img/list_5.8a2e040f.jpg";